import { TCountry, TIcon } from "@/api/v1_0";

export namespace Icon {
  export const bankIcons = (country: TCountry): Array<TIcon> =>
    _iconsBanks[country] || [];

  export const icons: Array<TIcon> = [
    TIcon.Advertisement,
    TIcon.Bag,
    TIcon.BarChart,
    TIcon.Basket,
    TIcon.Bitcoin,
    TIcon.Bone,
    TIcon.Book,
    TIcon.Briefcase,
    TIcon.Brightness,
    TIcon.Brush,
    TIcon.Calendar,
    TIcon.Cd,
    TIcon.Coffee,
    TIcon.Comment,
    TIcon.CreditCard,
    TIcon.Cross,
    TIcon.Cup,
    TIcon.Cursor,
    TIcon.Delivery,
    TIcon.Gears,
    TIcon.Gift,
    TIcon.Globe,
    TIcon.Heart,
    TIcon.Home,
    TIcon.Horse,
    TIcon.IceCream,
    TIcon.Laptop,
    TIcon.LightBulb,
    TIcon.Marker,
    TIcon.Mobile,
    TIcon.MusicNote,
    TIcon.Phone,
    TIcon.Pocket,
    TIcon.Rocket,
    TIcon.Shield,
    TIcon.Wallet,
    TIcon.Watch,
    TIcon.World,
  ];

  const _iconsBanks: { [key in TCountry]: Array<IIcon> } = {
    RUS: [
      TIcon.Akbars,
      TIcon.Alfabank,
      TIcon.Atb,
      TIcon.CitiBank,
      TIcon.Domrf,
      TIcon.Gazprom,
      TIcon.HomeCredit,
      TIcon.Mkb,
      TIcon.Mts,
      TIcon.Otkritie,
      TIcon.Otp,
      TIcon.Paypal,
      TIcon.PochtaBank,
      TIcon.Psbank,
      TIcon.Qiwi,
      TIcon.Raiffeisenbank,
      TIcon.Rnkb,
      TIcon.Rosbank,
      TIcon.RosgosstrakhBank,
      TIcon.RusskiyStandart,
      TIcon.Sberbank,
      TIcon.Skb,
      TIcon.Sovcombank,
      TIcon.Tinkoff,
      TIcon.Tochka,
      TIcon.Ubrd,
      TIcon.Unikredit,
      TIcon.Uralsib,
      TIcon.Vostochniy,
      TIcon.Vtb,
      TIcon.Yoomoney,
    ],
  };

  export type IIcon =
    | TIcon.Advertisement
    | TIcon.Bag
    | TIcon.BarChart
    | TIcon.Basket
    | TIcon.Bitcoin
    | TIcon.Bone
    | TIcon.Book
    | TIcon.Briefcase
    | TIcon.Brightness
    | TIcon.Brush
    | TIcon.Calendar
    | TIcon.Cd
    | TIcon.Coffee
    | TIcon.Comment
    | TIcon.CreditCard
    | TIcon.Cross
    | TIcon.Cup
    | TIcon.Cursor
    | TIcon.Delivery
    | TIcon.Gears
    | TIcon.Gift
    | TIcon.Globe
    | TIcon.Heart
    | TIcon.Home
    | TIcon.Horse
    | TIcon.IceCream
    | TIcon.Laptop
    | TIcon.LightBulb
    | TIcon.Marker
    | TIcon.Mobile
    | TIcon.MusicNote
    | TIcon.Phone
    | TIcon.Pocket
    | TIcon.Rocket
    | TIcon.Shield
    | TIcon.Wallet
    | TIcon.Watch
    | TIcon.World
    //	RU Banks.
    | TIcon.Akbars
    | TIcon.Alfabank
    | TIcon.Atb
    | TIcon.CitiBank
    | TIcon.Domrf
    | TIcon.Gazprom
    | TIcon.HomeCredit
    | TIcon.Mkb
    | TIcon.Mts
    | TIcon.Otkritie
    | TIcon.Otp
    | TIcon.Paypal
    | TIcon.PochtaBank
    | TIcon.Psbank
    | TIcon.Qiwi
    | TIcon.Raiffeisenbank
    | TIcon.Rnkb
    | TIcon.Rosbank
    | TIcon.RosgosstrakhBank
    | TIcon.RusskiyStandart
    | TIcon.Sberbank
    | TIcon.Skb
    | TIcon.Sovcombank
    | TIcon.Tinkoff
    | TIcon.Tochka
    | TIcon.Ubrd
    | TIcon.Unikredit
    | TIcon.Uralsib
    | TIcon.Vostochniy
    | TIcon.Vtb
    | TIcon.Yoomoney;

  //

  export const iconsKeys = icons;
}
